import React from 'react'
import { Transaction } from '@web/walter-lib/stream/types'
import { FormattedHTMLMessage, NotificationInfo } from '@web/walter-ui-kit'
import TxNotificationIcon from '../../TxNotificationIcon'
import AmountContent from '../AmountContent'
import { ProcessedNotificationData } from '../types'
import { getErrorNotification } from '../notifications'
import { lang } from './lang'

export const getFromTo = (subtype: Transaction['subtype']) => {
    if (subtype === 'DERIVATIVES_TO_WALLET') {
        return {
            from: <FormattedHTMLMessage {...lang.derivatives} />,
            to: <FormattedHTMLMessage {...lang.wallet} />,
        }
    }

    if (subtype === 'WALLET_TO_DERIVATIVES') {
        return {
            from: <FormattedHTMLMessage {...lang.wallet} />,
            to: <FormattedHTMLMessage {...lang.derivatives} />,
        }
    }

    if (subtype === 'SPOT_TO_WALLET') {
        return {
            from: <FormattedHTMLMessage {...lang.spot} />,
            to: <FormattedHTMLMessage {...lang.wallet} />,
        }
    }

    if (subtype === 'WALLET_TO_SPOT') {
        return {
            from: <FormattedHTMLMessage {...lang.wallet} />,
            to: <FormattedHTMLMessage {...lang.spot} />,
        }
    }

    return {
        from: null,
        to: null,
    }
}

export const processTransfer = (data: Transaction): ProcessedNotificationData | null => {
    /**
     * Data subtype usage:
     * WALLET_TO_DERIVATIVE: transfer from a wallet to a futures trading account
     * DERIVATIVES_TO_WALLET: transfer from a futures trading account to a wallet
     * WALLET_TO_SPOT: transfer from a wallet to a spot trading account
     * SPOT_TO_WALLET: transfer from a futures trading account to a wallet
     */

    /**
     * Currently only success and failed statuses processed
     * Pending and created statuses are processed as "pending" one-time notification triggered on REST request
     */
    if (data.status === 'SUCCESS') {
        const { from, to } = getFromTo(data.subtype)

        return {
            icon: <TxNotificationIcon status="SUCCESS" />,
            title: <FormattedHTMLMessage {...lang.successTitle} />,
            content: (
                <>
                    <NotificationInfo label={<FormattedHTMLMessage {...lang.successFrom} />} value={from} />
                    <NotificationInfo label={<FormattedHTMLMessage {...lang.successTo} />} value={to} />
                    <AmountContent
                        title={lang.successAmount}
                        amount={data.native?.amount || '0'}
                        sign={0}
                        currencyCode={data.native?.currency || ''}
                    />
                </>
            ),
            status: 'success',
            dataPointer: 'transfer_success_notification',
        }
    }

    if (data.status === 'FAILED') {
        return getErrorNotification({
            title: lang.errorTitle,
            content: lang.errorContent,
            dataPointer: 'transfer_failed_notification',
        })
    }

    return null
}
